(() => {
  "use strict";

  document.addEventListener("DOMContentLoaded", () => {
    // ==========================================================================
    //  FV
    // ==========================================================================

    gsap.config({
      nullTargetWarn: false,
    });
    const heroAnimeEase = Power2.easeInOut;
    const heroAnimeDuration = 0.8;
    const heroAnimeDelay01 = 0;
    const heroAnimeDelay02 = 0.4;
    const heroAnimeDelay03 = heroAnimeDelay02 + 0.6;
    const heroAnimeDelay04 = heroAnimeDelay03 + 0.2;
    const heroAnimeDelay05 = heroAnimeDelay04 + 0.6;
    const heroAnimeDelay06 = heroAnimeDelay05 + 0.1;

    gsap.timeline().fromTo(
      ".js-hero-anime01",
      {
        autoAlpha: 0,
        x: "-100",
      },
      {
        autoAlpha: 1,
        x: 0,
        duration: heroAnimeDuration,
        delay: heroAnimeDelay01,
        ease: heroAnimeEase,
      }
    );
    gsap.timeline().fromTo(
      ".js-hero-anime02",
      {
        autoAlpha: 0,
        x: "-100%",
      },
      {
        autoAlpha: 1,
        x: 0,
        duration: heroAnimeDuration,
        delay: heroAnimeDelay02,
        ease: heroAnimeEase,
      }
    );
    gsap.timeline().fromTo(
      ".js-hero-anime03",
      {
        autoAlpha: 0,
        x: "-100",
      },
      {
        autoAlpha: 1,
        x: 0,
        duration: heroAnimeDuration,
        delay: heroAnimeDelay03,
        ease: heroAnimeEase,
      }
    );
    gsap.timeline().fromTo(
      ".js-hero-anime04",
      {
        autoAlpha: 0,
        x: "-100",
      },
      {
        autoAlpha: 1,
        x: 0,
        duration: heroAnimeDuration,
        delay: heroAnimeDelay04,
        ease: heroAnimeEase,
      }
    );
    gsap.timeline().fromTo(
      ".js-hero-anime05",
      {
        autoAlpha: 0,
        y: "40",
      },
      {
        autoAlpha: 1,
        y: 0,
        duration: heroAnimeDuration,
        delay: heroAnimeDelay05,
        ease: heroAnimeEase,
      }
    );
    gsap.timeline().fromTo(
      ".js-hero-anime06",
      {
        autoAlpha: 0,
        y: "40",
      },
      {
        autoAlpha: 1,
        y: 0,
        duration: heroAnimeDuration,
        delay: heroAnimeDelay06,
        ease: heroAnimeEase,
      }
    );

    // ==========================================================================
    //  スムーズスクロール
    // ==========================================================================

    const headerId = "js-header";
    const header = document.getElementById(headerId);
    const headerHeight = header.offsetHeight;

    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        const href = anchor.getAttribute("href");
        const target = document.getElementById(href.replace("#", ""));
        const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      });
    });

    const url = new URL(location.href);
    const hash = url.hash.slice(1);
    const target = document.getElementById(hash);
    if (target) {
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      setTimeout(function () {
        window.scrollTo({ top: 0 }, 0);
      });
      setTimeout(function () {
        window.scrollTo({
          top: top,
          behavior: "smooth",
        });
      });
    }

    // ==========================================================================
    //  ハンバーガーメニュー
    // ==========================================================================

    const elementBody = document.body;
    const tl = gsap.timeline({ paused: true });

    document.querySelector("#js-menu-open").addEventListener("click", (event) => {
      // elementBody.classList.add("-menu-active");
      elementBody.style.overflow = "hidden";
      tl.play();
    });

    document.querySelector("#js-menu-close").addEventListener("click", (event) => {
      // elementBody.classList.remove("-menu-active");
      elementBody.style.overflow = "auto";
      tl.reverse();
    });

    tl.fromTo(
      "#js-nav",
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        duration: 0.3,
        ease: Power2.easeInOut,
      }
    );

    // ==========================================================================
    //  スクロールトップ
    // ==========================================================================
    const targetElement = document.getElementById("js-page-top");

    window.addEventListener("scroll", function () {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (scrollTop >= 200) {
        targetElement.classList.add("-active");
      } else {
        targetElement.classList.remove("-active");
      }
    });

    // ==========================================================================
    //  アコーディオン
    // ==========================================================================
    document.querySelectorAll(".js-details").forEach(function (el) {
      const summary = el.querySelector(".js-details-summary");
      const answer = el.querySelector(".js-details-answer");
      summary.addEventListener("click", (event) => {
        // デフォルトの挙動を無効化
        event.preventDefault();
        // detailsのopen属性を判定
        if (el.getAttribute("open") !== null) {
          // アコーディオンを閉じるときの処理
          const closingAnim = answer.animate(closingAnimation(answer), animTiming);

          closingAnim.onfinish = () => {
            // アニメーションの完了後にopen属性を取り除く
            el.removeAttribute("open");
          };
        } else {
          // open属性を付与
          el.setAttribute("open", "true");
          // アコーディオンを開くときの処理
          const openingAnim = answer.animate(openingAnimation(answer), animTiming);
        }
      });
    });
  });

  // アニメーションの時間とイージング
  const animTiming = {
    duration: 300,
    easing: "ease-in-out",
  };

  // アコーディオンを閉じるときのキーフレーム
  const closingAnimation = (answer) => [
    {
      height: answer.offsetHeight + "px",
      opacity: 1,
    },
    {
      height: 0,
      opacity: 0,
    },
  ];

  // アコーディオンを開くときのキーフレーム
  const openingAnimation = (answer) => [
    {
      height: 0,
      opacity: 0,
    },
    {
      height: answer.offsetHeight + "px",
      opacity: 1,
    },
  ];
})();
